import classnames from 'classnames'
import clr from 'color'
import React from 'react'
import type { PropsWithChildren, FC } from 'react'

import styles from './CardInfo.module.css'

export type Props = {
  color?: string
  type?: 'light' | 'smooth' | 'dark' | 'gray'
}

const getDarkerColor = value => {
  return value ? clr(value).darken(0.75).rgb().string() : null
}

const Content: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={classnames(styles.Text, styles.ellipsisContent)}>
      {children}
    </div>
  )
}

const RightContent: FC<PropsWithChildren<{ color?: string }>> = ({
  children,
  color = '#ffffff'
}) => {
  const darkerColor = getDarkerColor(color)
  const style = { backgroundColor: darkerColor }

  return (
    <div style={style} className={styles.RightAdornment}>
      <div className={styles.RightAdornmentContent}>{children}</div>
    </div>
  )
}
const Container: FC<PropsWithChildren<Props>> = ({ children, type, color }) => {
  const darkerColor = getDarkerColor(color)
  const textStyle = type !== 'gray' ? { color: darkerColor } : {}

  const containerStyles =
    type === 'dark' ? { backgroundColor: darkerColor, color } : textStyle

  const containerClassNames = classnames(styles.Container, {
    [styles.light]: type === 'light',
    [styles.smooth]: type === 'smooth',
    [styles.gray]: type === 'gray'
  })

  return (
    <div style={containerStyles} className={containerClassNames}>
      {children}
    </div>
  )
}

export default {
  Content,
  RightContent,
  Container
}
